/**
 *@author yudeping
 *创建默认表单或者定制表单
 */

import userHtml from  './talbe-form/form-version-table-user.html';
import departmentHtml from  './talbe-form/form-version-talbe-department.html';
import './talbe-form/form-version-talbe-department.scss'
import {FormService} from "../../../services/formService/formService"
export const CreateForm={
    name:{}, manager:{}, vice_manager:{}, parent:{}, is_group:{}, is_delete:{},username:{}, is_superuser:{}, is_active:{}, ip:{},
    email:{}, department_whole:{}, job:{}, status:{}, department:{}, tel:{},form_data:{},is_approver:{},
    //主岗部门list
    main_depart:[],
    //是否为超级管理员
    isSuperuser:{},
    //创建默认表单
    formDefaultVersion(data){
        let html=`<table class="form table table-striped table-bordered table-hover form-default">
            <tbody>
                `;
        for(let key in data){
            if(data[key].type==='Hidden'){
                html+=`<div data-dfield="${data[key].dfield}" data-type="${data[key].type}"></div>`;
            }else{
                html+=`<tr>
                        <td style="width: 150px;white-space: nowrap;">${ data[key].label }</td>
                        <td><div data-dfield="${data[key].dfield}" data-type="${data[key].type}"></div></td>
                </tr>`;
            }
        }
        html+=`</tbody>
        </table>`
        return html;
    },

	deferSetMainDepOptions(allData){
    	this.department=allData.data[this.form_data['department']];
		this.main_depart = allData.data[this.form_data.department]["options"];
		this.changeMainDepart(false)
		console.log('options')
		console.log(this.department["options"]);
		allData.data[this.form_data.department]["options"]=this.department['options'];
		allData.data[this.form_data.department_whole]['department']=_.defaultsDeep({},this.department);
		allData.data[this.form_data.department_whole]['main_depart']=_.defaultsDeep({},this.main_depart);
		return {dep:this.form_data.department,whole:this.form_data.department_whole};
	},

    changeMainDepart(isClick){
        let arr = [{value:'',label:'请选择'}];

        //判断是否需要将主岗部门置为请选择
        if( isClick ){
            let arr_1 = [];
            for( let i = 1;i<this.department["options"].length;i++ ){
                arr_1.push(this.department["options"][i]["value"]);
            }
            if( arr_1.length != this.department_whole.value.length ){
                this.setFormValue( this.form_data['department'],'' );
            }
        }
        //改变主岗部门option
        for( let i=0;i<this.department_whole.value.length;i++ ){
            for( let j=0;j<this.main_depart.length;j++ ){
                if( this.main_depart[j]["value"] === this.department_whole.value[i] ){
                    arr.push( this.main_depart[j] );
                }
            }
        }
        this.department["options"] = arr;
    },
    //创建人员信息表
    async formVersionuser(allData, fres){
        let data=allData.data;
        let html=userHtml.replace('</tbody> </table>','');
        let res=await FormService.getSysConfig();
        this.form_data=res.userInfo['system_config'][0]["field_mapping"];
        let arrData = [];
        let otherData=[];
        console.log('form_data', this.form_data)
        for( let i in this.form_data )
        {
            for ( let j in data)
            {
                if( this.form_data[i] == j )
                {
                    arrData.push( j );
                    this[i]=data[j];
                }
            }
        }
        console.log('arrData', arrData, this)
        //写入性别
        arrData.push('f34')
        // 人员信息 表单添加 移动端权限 字段 f45
        otherData.push(data['f45'])
        for( let k in data ){
            if( data[k]['real_type'] && arrData.indexOf( k ) == -1 && data[k].type !='Hidden' ){
                otherData.push( data[k] )
            }
        }
        console.log('otherData', otherData)
        if( this.username.value && this.username.value!='' ){
            this.username.is_view = '1';
        }

        this.is_superuser["group"] = [{'label': '是', 'value': "1"}, {'label': '否', 'value': "0"}];
        this.is_superuser["type"] = "radio";
        this.is_superuser["is_view"] = '1';
        this.is_superuser["value"] = this.is_superuser["value"] ? this.is_superuser["value"] + '' : '0';
        if( !this.isSuperuser && !( this.is_superuser["value"]=='1' ) ){
            this.is_superuser["value"] = '0';
        }
        this.is_active["group"] = [{'label': '是', 'value': "1"}, {'label': '否', 'value': "0"}];
        this.is_active["type"] = "radio";
        this.is_active["value"] = this.is_active["value"] + '';

        this.is_approver["group"] = [{'label': '是', 'value': "1"}, {'label': '否', 'value': "0"}];
        this.is_approver["type"] = "radio";
        this.is_approver["value"] = this.is_approver["value"] + '';

        this.status["type"] = 'select';
        this.status["label"] = '用户状态';
        this.status["options"] = [
            {value: "", label: '请选择'},
            {value: "0", label: '离职'},
            {value: "1", label: '正常'},
            {value: '6', label: '锁定'},
            // {value: "2", label: '实习'},
            // {value: "3", label: '试用'},
            // {value: "4", label: '管理员'},
            // {value: "5", label: '病休'}
        ];
        this.status["value"] = this.status["value"] + '';

        // this.main_depart = data[this.form_data.department]["options"];

        // this.changeMainDepart(false);
        // allData.data[this.form_data.department]["options"]=this.department['options'];
        allData.data[this.form_data.department_whole]['isSys']=true;
	    // allData.data[this.form_data.department_whole]['main_depart']=_.defaultsDeep({},this.main_depart);
	    // allData.data[this.form_data.department_whole]['department']=_.defaultsDeep({},this.department);
        allData.data[this.form_data.department_whole]['form_department']=this.form_data['department'];
	    let userInfoDfields=['f3','f6','f7','f9','f16','f11','f12','f14','f13','f15','f10','f34','f44'];
        // let userInfoDfields=['f3', 'f7','f9','f16','f11','f12','f14','f13','f15','f10','f34'];

        // for(let key in otherData){
            
        //     html+=`<tr class="firstRow">
        //     <td valign="top" >
        //     <span data-id="4" style="border: 2px currentColor; border-image: none;">${otherData[key].label}</span>
        //     </td>
        //     <td valign="top" colspan="3">
        //         <div data-dfield="${otherData[key].dfield}" data-type="${otherData[key].type}"></div>
        //     </td>
        //     </tr>`
        //     userInfoDfields.push(otherData[key].dfield);
        // }

        if(otherData.length > 0){
            html+= `<tr class="firstRow">`
            otherData.map((row, index) => {
                html+= `<td valign="top" >
                    <span data-id="4" style="border: 2px currentColor; border-image: none;">${row.label}</span>
                    </td>
                    <td valign="top">
                        <div data-dfield="${row.dfield}" data-type="${row.type}"></div>
                    </td>`;
                if(index % 2 == 1){
                    html += '</tr><tr>';
                }
                userInfoDfields.push(row.dfield);
            })

        }
        

        for(let key in allData.data){
        	let index = userInfoDfields.indexOf(key);
        	index!=-1?userInfoDfields.splice(index,1):'';
        }
        allData.userInfoDfields=userInfoDfields;

        html+=`</tbody>
            </table>
            <div data-dfield="temp_id" data-type="Hidden"></div>
            <div data-dfield="real_id" data-type="Hidden"></div>
            <div data-dfield="table_id" data-type="Hidden"></div>`
        return html;
    },
    //创建部门信息表
    async formVersiondepartment(allData, fres){
        let html=departmentHtml.replace('</tbody> </table>','');
        let res=await FormService.getSysConfig();
        let data=allData.data;
        let form_data=res.userInfo['system_config'][1]["field_mapping"];
        let arrData = [];
        let otherData=[];
        for( let i in form_data )
        {
            for ( let j in data)
            {
                if( form_data[i] == j )
                {
                    arrData.push( j );
                    this[i]=data[j];
                }
            }
        }
        for( let k in data ){
            if( data[k]['real_type'] && arrData.indexOf( k ) == -1 ){
                otherData.push( data[k] )
            }
        }
        this.is_delete["group"] = [{ 'label':'是','value':'1' },{ 'label':'否','value':'0'}];
        this.is_delete["type"] = "radio";
        this.is_delete["value"] = this.is_delete["value"] + '';

        this.is_group["group"] = [{ 'label':'是','value':'1' },{ 'label':'否','value':'0' }];
        this.is_group["type"] = "radio";
        this.is_group["value"] = this.is_group["value"] + '';

        if( allData["main_departments"].indexOf( data['f7']['value'] ) != -1 ){
            this.parent["options"] = [{value:'',label:'无父部门'}];
            this.parent["is_view"] = 1;
        }
        for(let key in otherData){
            if(otherData[key].type !='Hidden') {
                html += `<tr class="firstRow"><td valign="top" width="664"><span data-id="4"
                                                   style="border: 2px currentColor; border-image: none;">${otherData[key].label}</span></td>
                <td valign="top" width="664">
                    <div data-dfield="${otherData[key].dfield}" data-type="${otherData[key].type}"></div>
                </td></tr>`
            }
        }
        html+=`</tbody>
            </table>
            <div data-dfield="temp_id" data-type="Hidden"></div>
            <div data-dfield="real_id" data-type="Hidden"></div>
            <div data-dfield="table_id" data-type="Hidden"></div>`
        return html;
    },

    //创建消息推送表
    async formVersionnotice(allData, res){
        let html = '';
        if(res[2]['data']['content']){
            html = res[2]['data']['content'];
            let htmlList = html.split('</tr>');
            let htmlStr = `<tr> 
                    <td valign="top" width="244">
                        <span data-id="3539_jdCwuJCyXvuGCoHGECNQGm" style="border:2px">申请发送人员</span> 
                    </td> 
                    <td colspan="3" rowspan="1" style="word-break: break-all;" valign="top"> 
                        <div data-dfield="f13" data-type="PostMessageGetUsers"></div> 
                    </td> `;
            htmlList.splice(1, 1, htmlStr);
            html = htmlList.join('</tr>');
        }
        return html;
    },

    async creatSysTable(systype, data, res){
        let html=await this[`formVersion${systype}`](data, res);
        return html;
    }
}


// WEBPACK FOOTER //
// app/components/form/createFormVersionTable/createForm.js